import { css } from "@emotion/react"
import { Button, FileInputButton } from "component/button"
import { ChangeEvent, ChangeEventHandler, MouseEventHandler } from "react"
import { BiShare } from "react-icons/bi"

type Props = {
  buttonText: string
  progress: string | number
  onChange: ChangeEventHandler<HTMLInputElement>
  onUploadClick: MouseEventHandler
}

export const AddImage = (props: Props)=>{


  return (
    <>
      <div css={chooseButtonContainerCss}>
        <FileInputButton onChange={props.onChange}/>
      </div>
      <div css={uploadButtonContainerCss}>
        <Button onClick={props.onUploadClick} level={'primary'}><BiShare /> {props.buttonText}</Button>
      </div>
      <div css={progressContainerCss}>
        <p>アップロード状況</p>
        <progress value={props.progress} max="100"/>
      </div>
    </>
  )
}

const chooseButtonContainerCss = css`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const uploadButtonContainerCss = css`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const progressContainerCss=css`
  margin-top: 1rem ;
  padding: 10px;
  text-align: center;
`